import script from "./StickersToolsBorder.vue?vue&type=script&setup=true&lang=js"
export * from "./StickersToolsBorder.vue?vue&type=script&setup=true&lang=js"

import "./StickersToolsBorder.vue?vue&type=style&index=0&id=c3b86b7c&lang=scss"

const __exports__ = script;

export default __exports__